import { useTranslation } from 'react-i18next';
import { useSelectItemIds } from '@anytag/shared-hooks';
import { AnalyticsCompareOverviewLegendType } from '../../../shared';
import { AnalyticsInstagramCompareGraphKeys as Keys } from '../types';

export type UseAnalyticsInstagramCompareOverviewLegendProps = {
  defaultSelectedLegendKeys?: Keys[];
};
export const useAnalyticsInstagramCompareOverviewLegend = ({
  defaultSelectedLegendKeys = ['followers']
}: UseAnalyticsInstagramCompareOverviewLegendProps) => {
  const { t } = useTranslation();
  const {
    selectItem: setSelectedLegendKey,
    selectedItemIds: selectedLegendKeys,
    setSelectedItemIds: setSelectedLegendKeys
  } = useSelectItemIds<Keys>({ defaultSelectedIds: defaultSelectedLegendKeys });

  const legendOptions: AnalyticsCompareOverviewLegendType<Keys>[] = [
    { label: t<string>('Follower'), value: 'followers', type: 'checkbox' },
    { label: t<string>('Post'), value: 'posts', type: 'radio' },
    { label: t<string>('Like'), value: 'likes', type: 'radio' },
    { label: t<string>('Comment'), value: 'comments', type: 'radio' },
    { label: t<string>('Engagement'), value: 'engagement', type: 'radio' }
  ];
  const checkboxLegendKeys = legendOptions.filter((o) => o.type === 'checkbox').map((o) => o.value);

  const handleSelectLegendOption = ({ value, type }: AnalyticsCompareOverviewLegendType<Keys>) => {
    if (type === 'checkbox') {
      setSelectedLegendKey(value);
    } else {
      const selectedCheckboxKeys = selectedLegendKeys.filter((key) => checkboxLegendKeys.includes(key));
      setSelectedLegendKeys([...selectedCheckboxKeys, value]);
    }
  };

  return {
    legendOptions,
    selectedLegendKeys,
    handleSelectLegendOption
  };
};
